import React, { useState, useEffect } from 'react';
import CustomSelect from '../InputElements/CustomSelect';

const HeadingDropdownMenu = ({ editor }) => {
  const [currentHeading, setCurrentHeading] = useState('paragraph');

  // Update current heading when editor selection changes
  useEffect(() => {
    if (!editor) return;

    const updateCurrentHeading = () => {
      if (editor.isActive('heading', { level: 1 })) {
        setCurrentHeading('heading-1');
      } else if (editor.isActive('heading', { level: 2 })) {
        setCurrentHeading('heading-2');
      } else if (editor.isActive('heading', { level: 3 })) {
        setCurrentHeading('heading-3');
      } else if (editor.isActive('heading', { level: 4 })) {
        setCurrentHeading('heading-4');
      } else if (editor.isActive('heading', { level: 5 })) {
        setCurrentHeading('heading-5');
      } else if (editor.isActive('heading', { level: 6 })) {
        setCurrentHeading('heading-6');
      } else {
        setCurrentHeading('paragraph');
      }
    };

    updateCurrentHeading();
    editor.on('selectionUpdate', updateCurrentHeading);
    editor.on('transaction', updateCurrentHeading);

    return () => {
      editor.off('selectionUpdate', updateCurrentHeading);
      editor.off('transaction', updateCurrentHeading);
    };
  }, [editor]);

  if (!editor) return null;

  const headingOptions = [
    {
      value: 'paragraph',
      shortLabel: 'P',
      label: 'Paragraph',
      fontSize: '14px',
      fontWeight: 'normal'
    },
    {
      value: 'heading-1',
      shortLabel: 'H1',
      label: 'Heading 1',
      fontSize: '1.4rem',
      fontWeight: 'bold'
    },
    {
      value: 'heading-2',
      shortLabel: 'H2',
      label: 'Heading 2',
      fontSize: '1.2rem',
      fontWeight: 'bold'
    },
    {
      value: 'heading-3',
      shortLabel: 'H3',
      label: 'Heading 3',
      fontSize: '1.1rem',
      fontWeight: 'bold'
    },
    {
      value: 'heading-4',
      shortLabel: 'H4',
      label: 'Heading 4',
      fontSize: '1rem',
      fontWeight: 'bold'
    }
  ];

  const handleHeadingChange = (value) => {
    if (!editor.can().focus()) return;

    if (value === 'paragraph') {
      editor.chain().focus().clearNodes().setParagraph().run();
    } else {
      const level = parseInt(value.split('-')[1]);
      editor.chain().focus().clearNodes().setHeading({ level }).run();
    }
  };

  const customOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          padding: '0px 6px',
          fontSize: data.fontSize,
          fontWeight: data.fontWeight,
          cursor: 'pointer'
        }}>
        {data.label}
      </div>
    );
  };
  const selectedOption = headingOptions.find((opt) => opt.value === currentHeading)?.value;
  return (
    <div className="">
      <CustomSelect
        title=""
        labelClassName="form-label fs-1 fw-600 text-capitalize w-100"
        options={headingOptions}
        value={selectedOption}
        onChange={(selected) => {
          handleHeadingChange(selected.value);
        }}
        components={{
          Option: customOption,
          IndicatorSeparator: () => null
        }}
        controlStyle={{
          backgroundColor: 'transparent',
          border: 'none',
          boxShadow: 'none',
          outline: 'none'
        }}
        style={{
          dropdownIndicator: (base) => ({
            ...base,
            padding: 0,
            marginRight: 4
          })
        }}
        menuOnLeft
        className="mb-1"
        isSearchable={false}
        required
        isSm
      />
    </div>
  );
};

export default HeadingDropdownMenu;
